import { defineComponent as t, createBlock as a, openBlock as n, unref as c, mergeProps as r, withCtx as i, createElementVNode as p } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconOfficialFilled",
  __name: "IconOfficialFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const o = l;
    return (d, e) => (n(), a(c(f), r(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M9.53 3.401c.994-1.535 3.24-1.535 4.234 0A1.021 1.021 0 0 0 14.99 3.8c1.706-.658 3.523.663 3.425 2.489A1.021 1.021 0 0 0 19.17 7.33c1.767.47 2.461 2.607 1.308 4.026a1.021 1.021 0 0 0 0 1.288c1.153 1.42.46 3.556-1.308 4.026a1.021 1.021 0 0 0-.757 1.042c.098 1.826-1.719 3.147-3.425 2.489a1.021 1.021 0 0 0-1.225.398c-.993 1.535-3.24 1.535-4.233 0A1.021 1.021 0 0 0 8.306 20.2C6.6 20.859 4.782 19.538 4.88 17.712a1.021 1.021 0 0 0-.757-1.042c-1.767-.47-2.462-2.607-1.308-4.026a1.021 1.021 0 0 0 0-1.288C1.662 9.936 2.356 7.8 4.124 7.33A1.021 1.021 0 0 0 4.88 6.288C4.782 4.462 6.6 3.14 8.306 3.799A1.021 1.021 0 0 0 9.53 3.401m7.018 6.11a.75.75 0 1 0-1.096-1.023L10.4 13.901l-1.852-1.984a.75.75 0 0 0-1.096 1.023l2.034 2.18a1.25 1.25 0 0 0 1.828 0l5.234-5.608",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
